module.exports = __webpack_public_path__ + "img/IMG_6558_P_L_WoodMatted.e733b617.jpg";